const name_pairs = {
  ww: 'Global Website',
  fr: 'France',
  us: 'USA',
  pl: 'Poland',
  ca_en: 'Canada',
  ca_fr: 'Canada',
  za_en: 'South Africa',
};
/**
 * Returns english country name based on cc,lc pair, so that placeholder label can be shown.
 * If there is no label for given country, returns cc_lc.
 * @param cc Country name as two-letter symbol
 * @param lc Language name as two-letter symbol
 */
export default function (cc: string, lc: string) {
    if (name_pairs.hasOwnProperty(cc)) return name_pairs[cc];

    const full_name = `${cc}_${lc}`;
    if (name_pairs.hasOwnProperty(full_name)) return name_pairs[full_name];

    return full_name;
}
